import { linkHelper } from "../../helper/LinkHelper";
export const AuthorBioBtns = ({ bookUrl, blogUrl, author_slug }) => {
  return (
    <div style={{ clear: "both", paddingTop: "20px" }}>
      {bookUrl &&
        bookUrl !== "" &&
        linkHelper({
          url: `/author-books?author_slug=${author_slug}`,
          title: "View Books",
          cls: "btn btn-primary",
        })}{" "}
      {blogUrl &&
        blogUrl !== "" &&
        linkHelper({
          url: `/authorblog?author_slug=${author_slug}`,
          title: "Read Blog",
          cls: "btn btn-primary",
        })}
    </div>
  );
};
